<template>
    <div>
        <el-dialog v-model="examinationAnalysis" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false" :before-close="handleClose">
            <template #header>
                <div class="header">试卷分析</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>

            <div class="dialog_content" ref="dialogContent" v-loading="loading">
                <!-- 难度星级 -->
                <div class="difficult_star flex Flexalign">
                    <div class="difficult_star_label">难度星级</div>
                    <div class="ml-40 flex-1 difficult_star_value">
                        {{ getDifficultStar(paperInfo.document?.difficulty) }}
                    </div>
                </div>

                <!-- 考察范围 -->
                <div class="difficult_star flex FlexStart mt-20">
                    <div class="difficult_star_label">考察范围</div>
                    <div class="ml-40 flex-1 difficult_star_value">
                        {{ inspectRangeString }}
                    </div>
                </div>

                <!-- 试卷题型和难度 -->
                <div class="examination_title flex mt-20 FlexBetween">
                    <!-- 左侧：试卷题型 -->
                    <div class="examination_title_left">
                        <div class="examination_subtitle flex Flexalign">
                            <div class="green_line"></div>
                            <div class="ml-10">试卷题型（共 {{ totalQuestions }}题）</div>
                        </div>
                        <div class="table-fixed-container">
                            <el-table :data="cachedQuestionTypeData" style="width: 100%;" height="280" class="mt-20"
                                stripe>
                                <el-table-column prop="questionType" label="题型" min-width="120" />
                                <el-table-column prop="questionNumbers" label="数量" width="80" align="center" />
                            </el-table>
                        </div>
                    </div>

                    <!-- 右侧：试卷难度 -->
                    <div class="examination_title_left">
                        <div class="examination_subtitle flex Flexalign">
                            <div class="green_line"></div>
                            <div class="ml-10">试卷难度</div>
                        </div>
                        <div class="chart-fixed-container">
                            <examinationDifficultPie ref="examinationDifficultPie"></examinationDifficultPie>
                        </div>
                    </div>
                </div>

                <!-- 知识点分析 -->
                <div class="examination_title flex mt-20 FlexBetween">
                    <div class="examination_title_left examination_title_all">
                        <div class="examination_subtitle flex Flexalign">
                            <div class="green_line"></div>
                            <div class="ml-10">知识点分析</div>
                        </div>
                        <div class="table-fixed-container knowledge-table">
                            <el-table :data="cachedKnowledgeData" style="width: 100%;" height="180" class="mt-20"
                                stripe>
                                <el-table-column prop="index" label="序号" width="80" align="center" />
                                <el-table-column prop="knowledge" label="知识点" />
                                <el-table-column prop="questionNumbers" label="对应题号" />
                            </el-table>
                        </div>
                    </div>
                </div>

                <!-- 细目表分析 -->
                <div class="examination_title flex mt-20 FlexBetween">
                    <div class="examination_title_left examination_title_all">
                        <div class="examination_subtitle flex Flexalign">
                            <div class="green_line"></div>
                            <div class="ml-10">细目表分析</div>
                        </div>
                        <div class="table-fixed-container detail-table">
                            <el-table :data="cachedDetailData" style="width: 100%;" class="mt-20" stripe>
                                <el-table-column prop="index" label="序号" width="150" align="center" />
                                <el-table-column prop="difficultyCoefficient" label="难度系数" align="center" />
                                <el-table-column prop="questionNumbers" label="对应题号" align="center" />
                                <el-table-column prop="knowledgePoint" label="知识点" />
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import examinationDifficultPie from '../echarts/examinationDifficultPie.vue';
import { CloseBold } from '@element-plus/icons-vue';

export default {
    name: "GjkcH5ExaminationAnalysis",
    components: {
        examinationDifficultPie,
        CloseBold
    },
    computed: {
        // 考察范围字符串
        inspectRangeString() {
            if (!this.paperInfo?.knowledgeList || !Array.isArray(this.paperInfo.knowledgeList)) {
                return '暂无考察范围'
            }
            return this.paperInfo.knowledgeList.map(item => item.knowledgeName).join('、')
        },

        // 总题数
        totalQuestions() {
            if (!this.paperInfo.paper?.paperContext) return 0;
            return this.paperInfo.paper.paperContext.reduce((total, section) => {
                return total + (section.questions?.length || 0);
            }, 0);
        },

        // 缓存题型数据
        cachedQuestionTypeData() {
            return this.questionTypeData(this.paperInfo.paper);
        },

        // 缓存知识点数据
        cachedKnowledgeData() {
            return this.knowledgeData(this.paperInfo.paper);
        },

        // 缓存细目表数据
        cachedDetailData() {
            return this.detailData(this.paperInfo.paper);
        }
    },
    data() {
        return {
            examinationAnalysis: false,
            paperInfo: {
                document: {},
                paper: {
                    paperContext: []
                },
                knowledgeList: []
            },
            loading: false,
            resizeObserver: null,
            initTimer: null
        };
    },
    watch: {
        // 监听弹窗关闭，销毁图表
        examinationAnalysis(val) {
            if (!val) {
                this.destroyChart();
            }
        }
    },
    mounted() {
        this.initResizeObserver();
    },
    methods: {
        // 初始化ResizeObserver
        initResizeObserver() {
            if (!window.ResizeObserver) return;

            this.resizeObserver = new ResizeObserver(() => {
                // 使用requestAnimationFrame避免频繁触发
                requestAnimationFrame(() => {
                    // 这里不需要做任何事，只是为了防止默认行为
                });
            });

            this.$nextTick(() => {
                if (this.$refs.dialogContent) {
                    this.resizeObserver.observe(this.$refs.dialogContent);
                }
            });
        },

        // 关闭弹窗
        closePopup() {
            this.examinationAnalysis = false;
        },

        // 处理关闭
        handleClose(done) {
            this.destroyChart();
            done();
        },

        // 销毁图表
        destroyChart() {
            if (this.$refs.examinationDifficultPie) {
                this.$refs.examinationDifficultPie.destroyChart();
            }
        },

        // 初始化数据
        initData(paperId) {
            // 先销毁之前的图表
            this.destroyChart();

            // 清空之前的定时器
            if (this.initTimer) {
                clearTimeout(this.initTimer);
            }

            // 显示弹窗和loading
            this.examinationAnalysis = true;
            this.loading = true;

            // 清空旧数据
            this.paperInfo = {
                document: {},
                paper: {
                    paperContext: []
                },
                knowledgeList: []
            };

            // 调用接口
            this.$Api.examination.examinationAnalysis(paperId).then(res => {
                this.paperInfo = res.data.data;
                this.loading = false;

                // 等待弹窗动画完成和DOM更新后初始化图表
                this.initTimer = setTimeout(() => {
                    this.$nextTick(() => {
                        if (this.$refs.examinationDifficultPie) {
                            this.difficultyData(this.paperInfo.paper)
                        }
                    });
                }, 300);

            }).catch(() => {
                this.loading = false;
                this.$message.error('获取试卷分析失败');
            });
        },

        // 难度星级
        getDifficultStar(difficulty) {
            if (difficulty === undefined || difficulty === null || isNaN(difficulty)) {
                return '暂无难度'
            }

            const actualDifficulty = (difficulty / 2).toFixed(1)

            const levelMap = [
                { max: 1, level: '超易' },
                { max: 3, level: '容易' },
                { max: 5, level: '中档' },
                { max: 6, level: '困难' },
                { max: Infinity, level: '极难' }
            ]

            const difficultLevel = levelMap.find(item => actualDifficulty <= item.max).level

            return `${actualDifficulty} 星（${difficultLevel}）`
        },

        // 细目表分析数据
        detailData(paper) {
            if (!paper || !paper.paperContext) {
                return []
            }

            const result = []
            let questionIndex = 1

            paper.paperContext.forEach(section => {
                // 添加题型标题行
                const titleIndex = result.filter(item => !item.difficultyCoefficient).length + 1;
                result.push({
                    index: `${this.getChineseNumber(titleIndex)}、${section.questionTypeName}`,
                    difficultyCoefficient: '',
                    questionNumbers: '',
                    knowledgePoint: '',
                    isTitle: true  // 标记为标题行
                })

                // 添加该题型下的所有题目
                section.questions.forEach(question => {
                    const knowledgeNames = this.getKnowledgeNames(question.knowledgeId)
                    result.push({
                        index: questionIndex.toString(),
                        difficultyCoefficient: question.difficultyCoefficient ? question.difficultyCoefficient.toFixed(2) : '0.00',
                        questionNumbers: question.questionNumber?.toString() || '',
                        knowledgePoint: knowledgeNames.join('、') || '暂无知识点',
                        isTitle: false
                    })
                    questionIndex++
                })
            })

            return result
        },

        // 获取中文数字
        getChineseNumber(num) {
            const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
            return num <= 10 ? chineseNumbers[num - 1] : num.toString()
        },

        // 根据知识点ID获取知识点名称
        getKnowledgeNames(knowledgeId) {
            if (!knowledgeId || !this.paperInfo.knowledgeList?.length) return []

            const knowledgeIds = knowledgeId.split(',').filter(id => id && id.trim())
            return knowledgeIds.map(id => {
                const knowledge = this.paperInfo.knowledgeList.find(k => k.knowledgeId == id.trim())
                return knowledge ? knowledge.knowledgeName : null
            }).filter(name => name !== null)
        },

        // 知识点分析数据
        knowledgeData(paper) {
            if (!paper || !paper.paperContext || !this.paperInfo.knowledgeList?.length) {
                return []
            }

            const knowledgeMap = new Map()

            paper.paperContext.forEach(section => {
                section.questions.forEach(question => {
                    if (question.knowledgeId) {
                        const knowledgeIds = question.knowledgeId.split(',').filter(id => id && id.trim())
                        knowledgeIds.forEach(id => {
                            const knowledgeId = id.trim()
                            const knowledge = this.paperInfo.knowledgeList.find(k => k.knowledgeId == knowledgeId)
                            if (knowledge) {
                                if (!knowledgeMap.has(knowledgeId)) {
                                    knowledgeMap.set(knowledgeId, {
                                        knowledgeName: knowledge.knowledgeName,
                                        questionNumbers: []
                                    })
                                }
                                if (question.questionNumber) {
                                    knowledgeMap.get(knowledgeId).questionNumbers.push(question.questionNumber)
                                }
                            }
                        })
                    }
                })
            })

            // eslint-disable-next-line no-unused-vars
            return Array.from(knowledgeMap.entries()).map(([knowledgeId, data], index) => ({
                index: index + 1,
                knowledge: data.knowledgeName,
                questionNumbers: data.questionNumbers.join(', ')
            }))
        },

        // 题型汇总
        questionTypeData(paper) {
            if (!paper || !paper.paperContext) {
                return []
            }

            return paper.paperContext.map((section, index) => ({
                index: index + 1,
                questionType: section.questionTypeName || '未知题型',
                questionNumbers: section.questions?.length || 0
            }))
        },
        // 饼图数据 - 根据实际题目难度分布计算
        difficultyData(paper) {
            if (!paper || !paper.paperContext) {
                return
            }
            if (!paper.paperContext) {
                return [
                    { name: '超易', value: 4, color: '#67C23A' },
                    { name: '容易', value: 4, color: '#91CC75' },
                    { name: '中档', value: 6, color: '#E6A23C' },
                    { name: '困难', value: 10, color: '#F56C6C' },
                    { name: '极难', value: 10, color: '#C45656' }
                ]
            }

            let superEasyCount = 0
            let easyCount = 0
            let mediumCount = 0
            let hardCount = 0
            let superHardCount = 0

            paper.paperContext.forEach(section => {
                section.questions.forEach(question => {
                    // 将题目难度转换为1-5星标准（除以2）
                    const difficulty = (question.difficulty || 0) / 2

                    if (difficulty <= 1) {
                        superEasyCount++
                    } else if (difficulty <= 3) {
                        easyCount++
                    } else if (difficulty <= 5) {
                        mediumCount++
                    } else if (difficulty <= 6) {
                        hardCount++
                    } else {
                        superHardCount++
                    }
                })
            })

            let echartsData = [
                { name: '超易', value: superEasyCount, color: '#67C23A' },
                { name: '容易', value: easyCount, color: '#91CC75' },
                { name: '中档', value: mediumCount, color: '#E6A23C' },
                { name: '困难', value: hardCount, color: '#F56C6C' },
                { name: '极难', value: superHardCount, color: '#C45656' }
            ]

            this.$refs.examinationDifficultPie.initCharts(echartsData);
        }
    },
    beforeUnmount() {
        // 断开ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }

        // 清除定时器
        if (this.initTimer) {
            clearTimeout(this.initTimer);
        }

        // 销毁图表
        this.destroyChart();
    }
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 820px;
    min-height: 600px;
    position: relative;

    .el-dialog__header {
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;
        text-align: start;
        margin-right: 0;
        border-bottom: 1px solid #f0f0f0;
    }

    .el-dialog__body {
        padding: 20px;
        max-height: 70vh;
        overflow-y: auto;
    }
}

.header {
    font-size: 18px;
    color: #333333;
    line-height: 60px;
    font-weight: 500;
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #999;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
        color: #333;
    }
}

:deep(.el-table th.el-table__cell) {
    background-color: #F5F7FA;
    color: #333;
    font-weight: 500;
}

:deep(.el-table td.el-table__cell) {
    color: #606060;
}

.dialog_content {
    .difficult_star {
        .difficult_star_label {
            color: #303030;
            font-weight: 500;
            min-width: 70px;
        }

        .difficult_star_value {
            color: #606060;
        }
    }

    .examination_title {
        gap: 20px;

        .examination_title_left {
            flex: 1;
            min-width: 0;

            .examination_subtitle {
                color: #303030;
                font-weight: 500;

                .green_line {
                    width: 3px;
                    height: 14px;
                    background: #1FD294;
                    border-radius: 2px;
                }
            }

            // 图表容器
            .chart-fixed-container {
                width: 100%;
                height: 280px;
                margin-top: 15px;
                background: #fafafa;
                border-radius: 8px;
                overflow: hidden;

                .examination_difficult_pie {
                    width: 100%;
                    height: 100%;
                }
            }

            // 表格容器
            .table-fixed-container {
                width: 100%;
                // height: 280px;
                margin-top: 15px;
                border-radius: 8px;
                overflow: hidden;
                border: 1px solid #f0f0f0;

                :deep(.el-table) {
                    height: 100% !important;

                    .el-table__header-wrapper {
                        background-color: #F5F7FA;
                    }

                    .el-table__body-wrapper {
                        height: calc(100% - 40px) !important;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            width: 6px;
                            height: 6px;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: #ddd;
                            border-radius: 3px;
                        }

                        &::-webkit-scrollbar-track {
                            background: #f5f5f5;
                        }
                    }
                }
            }

            // 知识点表格和细目表表格的高度调整
            .knowledge-table,
            .detail-table {
                // height: 180px;

                :deep(.el-table__body-wrapper) {
                    height: calc(100% - 40px) !important;
                }
            }
        }

        .examination_title_all {
            width: 100%;
        }
    }
}

// 加载状态
:deep(.el-loading-mask) {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
}
</style>